var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuoLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03a65b",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 1.5 1.5 V 3.5 H 2.5 H 17.5 H 18.5 V 1.5 H 1.5 Z M 19 5 C 19.6 5 20 4.6 20 4 V 1 C 20 0.4 19.6 0 19 0 H 1 C 0.4 0 0 0.4 0 1 V 4 C 0 4.6 0.4 5 1 5 V 16 C 1 16.6 1.4 17 2 17 H 6 H 7.5 H 12.5 H 14 H 18 C 18.6 17 19 16.6 19 16 V 5 Z M 17.5 5 H 2.5 V 15.5 H 6 V 8 C 6 7.4 6.4 7 7 7 H 13 C 13.6 7 14 7.4 14 8 V 15.5 H 17.5 V 5 Z M 12.5 13 V 11.5 H 7.5 V 13 H 12.5 Z M 12.5 14.5 H 7.5 V 15.5 H 12.5 V 14.5 Z M 12.5 8.5 V 10 H 7.5 V 8.5 H 12.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuoLocationIcon);
export default __webpack_public_path__ + "static/media/muo-location-icon.25a2146dfe1a65728c1c552ddf760e15.svg";
export { ForwardRef as ReactComponent };